import type { ThemedCssFunction, SimpleInterpolation, PortalTheme } from 'styled-components';
import { css } from 'styled-components';
import { sizes } from './sizes-viewport';

const generateBreakpoint = (minSize: number, maxSize?: number) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emMinSize = minSize / 16;
    const emMaxSize = maxSize && maxSize / 16;
    let mediaQuery: string;

    if (emMinSize && emMaxSize) {
        mediaQuery = `(min-width: ${emMinSize}em) and (max-width: ${emMaxSize})`;
    } else if (emMinSize) {
        mediaQuery = `(min-width: ${emMinSize}em)`;
    } else if (emMaxSize) {
        mediaQuery = `(max-width: ${emMaxSize}em)`;
    }

    const func: ThemedCssFunction<PortalTheme> = (
        strings: TemplateStringsArray,
        ...interpolations: SimpleInterpolation[]
    ) =>
        css`
            @media ${mediaQuery} {
                ${css(strings, ...interpolations)};
            }
        `;

    return {
        // So we get syntax highlighting easily.
        css: func,
    };
};

export const fromCustom = (minSize: number, maxSize?: number) => generateBreakpoint(minSize, maxSize);

export const fromMobile = generateBreakpoint(sizes.xxsmall);
export const onlyMobile = generateBreakpoint(0, sizes.xxsmall);

export const onlyXXSmall = generateBreakpoint(0, sizes.xxsmall);
export const fromXXSmall = generateBreakpoint(sizes.xxsmall);

export const onlyXSmall = generateBreakpoint(sizes.xsmall, sizes.small - 1);
export const fromXSmall = generateBreakpoint(sizes.xsmall);

export const onlySmall = generateBreakpoint(sizes.small, sizes.medium - 1);
export const fromSmall = generateBreakpoint(sizes.small);

export const onlyMedium = generateBreakpoint(sizes.medium, sizes.large - 1);
export const fromMedium = generateBreakpoint(sizes.medium);

export const onlyLarge = generateBreakpoint(sizes.large, sizes.xlarge - 1);
export const fromLarge = generateBreakpoint(sizes.large);

export const onlyXLarge = generateBreakpoint(sizes.xlarge, sizes.xxlarge - 1);
export const fromXLarge = generateBreakpoint(sizes.xlarge);

export const fromXXLarge = generateBreakpoint(sizes.xxlarge);
